import React from "react"
import PropTypes from "prop-types"

/**
 * PageHeader — compact inline title bar for listing/index pages.
 * Renders as a flat flex row (no card wrapper) to minimize vertical space.
 *
 * @param {string}  title      - Page title (required, renders Marianina ALL CAPS)
 * @param {string}  [subtitle] - Optional description (gray text, same line on desktop)
 * @param {React.ReactNode} [children] - Right-side actions (buttons, search, etc.)
 * @param {string}  [className] - Optional additional CSS class
 */
PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
}

export default function PageHeader({ title, subtitle, children, className }) {
  return (
    <div
      className={`page-header-inline ${className || ""}`}
      data-testid="page-header"
    >
      <div className="page-header-left">
        <h1 className="page-header-title">{title}</h1>
        {subtitle && (
          <span
            className="page-header-subtitle"
            style={{ fontSize: "var(--font-size-1)" }}
          >
            {subtitle}
          </span>
        )}
      </div>
      {children && (
        <div className="flex items-center gap-2 page-header-actions">
          {children}
        </div>
      )}
    </div>
  )
}
